import * as React from 'react';
import classnames from 'classnames';
import { Icon } from '@grandvisionhq/icons';
import { useIntl } from '@grandvisionhq/state';

const FacetSearchBox = ({ onSearch , className  })=>{
    const { getLabel  } = useIntl();
    const handleChange = (event)=>onSearch(event.target.value)
    ;
    return /*#__PURE__*/ React.createElement("div", {
        className: classnames('facet-searchbox', className)
    }, /*#__PURE__*/ React.createElement("input", {
        className: "facet-searchbox__input",
        type: "search",
        onChange: handleChange,
        placeholder: getLabel('search.filters.placeholder'),
        "data-t": "facet-searchbox"
    }), /*#__PURE__*/ React.createElement(Icon, {
        name: "search",
        className: "facet-searchbox__icon"
    }));
};

export { FacetSearchBox, FacetSearchBox as default };
//# sourceMappingURL=FacetSearchBox.js.map
